(function () {
  const HEART_ICON_OFF =
    'https://cdn.shopify.com/s/files/1/0845/4868/2025/files/favorite_15049598_82aa8183-b7c2-4dcc-9d8f-8c80819e0efc.png?v=1770716944';
  const HEART_ICON_ON =
    'https://cdn.shopify.com/s/files/1/0845/4868/2025/files/heart_94862_dd201a2a-c9bc-45d7-9c9e-6257b1120c74.png?v=1770718784';

  const ICON_MINUS =
    '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z" fill="currentColor"></path></svg>';
  const ICON_PLUS =
    '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z" fill="currentColor"></path></svg>';
  const ICON_CHECK =
    '<svg class="icon icon-check" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3.75 13.5L9 18.75L21 6.75"/></svg>';

  const ICON_SEARCH =
    '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-magnifying-glass"><path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z"/><path d="M16.4434 16.4453L20.9997 21.0016"/></svg>';

  const VIEW_KEY ='theme:wishlists:view'; // last list opened on the wishlist page
  const SHARED_MAX_ITEMS = 100;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, s => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[s]));
  }

  function itemCount(n) {
    return n + (n === 1 ? ' item' : ' items');
  }

  function updateButtons() {
    const list = (window.Wishlist && window.Wishlist.read()) || [];

    // Header heart badge: number of different products saved across all lists
    document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
      badge.textContent = list.length > 99 ? '99+' : String(list.length);
      badge.hidden = !list.length;
      badge.closest('a')?.setAttribute('aria-label', list.length ? `Wishlist (${itemCount(list.length)})` : 'Wishlist');
    });

    document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
      const handle = btn.getAttribute('data-product-handle');
      const active = list.includes(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');

      const activeText = btn.getAttribute('data-active-text') || 'Wishlisted';
      const idleText = btn.getAttribute('data-idle-text') || 'Add to wishlist';
      btn.querySelector('[data-wishlist-label]')?.replaceChildren(document.createTextNode(active ? activeText : idleText));
    });
  }

  // ---------------- "Save to list" dialog ----------------
  let dialog = null;
  let dialogHandle = null;

  function ensureDialog() {
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'wl-dialog';
    dialog.setAttribute('aria-labelledby', 'WlDialogTitle');
    dialog.innerHTML = `
      <div class="wl-dialog__inner">
        <div class="wl-dialog__head">
          <h2 id="WlDialogTitle" class="wl-dialog__title">Save to a list</h2>
          <button type="button" class="wl-dialog__close" data-wl-close aria-label="Close">&times;</button>
        </div>
        <p class="wl-dialog__hint">Organise products by room, age group, learning area or service.</p>
        <ul class="wl-dialog__lists" data-wl-lists></ul>
        <form class="wl-dialog__new" data-wl-new>
          <label class="visually-hidden" for="WlDialogNewName">New list name</label>
          <input id="WlDialogNewName" type="text" name="name" maxlength="60" placeholder="New list, e.g. Toddler Room" autocomplete="off" required>
          <button type="submit" class="btn btn--secondary">Create</button>
        </form>
        <div class="wl-dialog__foot">
          <a href="/pages/wishlist" class="wl-dialog__view" data-wl-view>View my lists</a>
          <button type="button" class="btn btn--primary" data-wl-close>Done</button>
        </div>
      </div>
    `;
    document.body.appendChild(dialog);

    // Close on the X / Done buttons, or a click on the backdrop
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog || e.target.closest('[data-wl-close]')) dialog.close();
    });

    dialog.addEventListener('change', (e) => {
      const checkbox = e.target.closest('[data-wl-list-id]');
      if (!checkbox) return;
      const id = checkbox.getAttribute('data-wl-list-id');
      checkbox.checked ? window.Wishlist.addTo(id, dialogHandle) : window.Wishlist.removeFrom(id, dialogHandle);

      // Update the count in place so keyboard focus stays on the checkbox
      const list = window.Wishlist.getList(id);
      const count = checkbox.closest('li').querySelector('[data-wl-count]');
      if (list && count) count.textContent = itemCount(list.items.length);
    });

    dialog.querySelector('[data-wl-new]').addEventListener('submit', (e) => {
      e.preventDefault();
      const input = e.target.elements.name;
      if (!input.value.trim()) return;
      window.Wishlist.createList(input.value, [dialogHandle]);
      input.value = '';
      renderDialogLists();
    });

    return dialog;
  }

  function renderDialogLists() {
    const ul = dialog.querySelector('[data-wl-lists]');
    ul.innerHTML = window.Wishlist.getLists().map(l => `
      <li>
        <label class="wl-dialog__list">
          <input type="checkbox" data-wl-list-id="${escapeHtml(l.id)}" ${l.items.includes(dialogHandle) ? 'checked' : ''}>
          <span class="wl-dialog__list-name">${escapeHtml(l.name)}</span>
          <span class="wl-dialog__list-count" data-wl-count>${itemCount(l.items.length)}</span>
        </label>
      </li>
    `).join('');
  }

  function openDialog(handle, viewUrl) {
    ensureDialog();
    dialogHandle = handle;

    // With a single list, the heart saves straight away; the dialog then offers more lists.
    const lists = window.Wishlist.getLists();
    if (lists.length === 1 && !window.Wishlist.has(handle)) window.Wishlist.addTo(lists[0].id, handle);

    dialog.querySelector('[data-wl-view]').setAttribute('href', viewUrl || '/pages/wishlist');
    renderDialogLists();
    if (!dialog.open) dialog.showModal();
  }

  function bindButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;

      e.preventDefault();

      const handle = btn.getAttribute('data-product-handle');
      if (!handle || !window.Wishlist) return;

      openDialog(handle, btn.getAttribute('data-wishlist-redirect'));
    });
  }

  // ---------------- Product cards (wishlist page) ----------------
  function formatPrice(cents) {
    const hasFoxTheme = window.FoxTheme && FoxTheme.Currency && FoxTheme.settings;
    if (hasFoxTheme) {
      try {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      } catch (e) {}
    }
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' })
      .format((cents || 0) / 100);
  }

  function priceMarkup(product) {
    const compareAt = product.compare_at_price;
    const price = product.price;
    const onSale = compareAt && compareAt > price;

    if (!onSale) {
      return `
        <div class="f-price text-left">
          <div class="f-price__regular">
            <span class="f-price-item f-price-item--regular">${formatPrice(price)}</span>
          </div>
        </div>
      `;
    }

    return `
      <div class="f-price f-price--on-sale text-left">
        <div class="f-price__sale">
          <span class="f-price-item f-price-item--sale">${formatPrice(price)}</span>
          <span class="f-price-item f-price-item--regular"><s>${formatPrice(compareAt)}</s></span>
        </div>
      </div>
    `;
  }

  function cardMarkup(product, index, removable) {
    const variant = (product.variants && product.variants[0]) || {};
    const available = variant.available !== undefined ? variant.available : product.available;
    const img = product.featured_image || (product.images && product.images[0]) || '';
    const title = escapeHtml(product.title);
    const handle = escapeHtml(product.handle);
    const formId = 'WishlistAddForm-' + index;

    return `
      <div class="f-column card">
        <div class="product-card product-card-style-standard">
          <div class="product-card__wrapper h-full">
            <div class="product-card__image-wrapper product-card__image-wrapper--main-only bg-none">
              <a href="${product.url}" aria-label="${title}" tabindex="-1">
                <div class="media-wrapper product-card__image product-card__image--main" style="--aspect-ratio: 3/4">
                  ${img ? `<img src="${img}" alt="${title}" loading="lazy">` : ''}
                </div>
              </a>
              <div class="product-card__hover-actions">
                <button
                  class="wl-btn-heart heart-image"
                  type="button"
                  data-wishlist-btn
                  data-product-handle="${handle}"
                  data-idle-text="Add to wishlist"
                  data-active-text="Wishlisted"
                  aria-pressed="true"
                >
                  <img src="${HEART_ICON_OFF}" class="NoColor" alt="Add to wishlist">
                  <img src="${HEART_ICON_ON}" class="ColoredHeart" alt="Wishlisted">
                </button>
                <a href="${product.url}" class="wl-card-view" aria-label="View ${title}">${ICON_SEARCH}</a>
              </div>
            </div>
            <div class="product-card__info text-left">
              <h3 class="product-card__title text-pcard-title">
                <a class="reversed-link" href="${product.url}">${title}</a>
              </h3>
              ${priceMarkup(product)}
            </div>
          </div>
        </div>

        <div class="collection-add-cart-wrap">
          <div class="collection-add-notice" role="status" aria-live="polite" hidden>
            ${ICON_CHECK}
            <span>Added to cart</span>
          </div>
          <form
            id="${formId}"
            class="collection-add-cart-form flex items-center gap-3"
            data-variant-id="${variant.id || ''}"
          >
            ${
              available
                ? `
              <quantity-input class="quantity collection-add-cart-qty">
                <button class="quantity__button" name="minus" type="button">
                  <span class="visually-hidden">Decrease quantity</span>
                  ${ICON_MINUS}
                </button>
                <input class="quantity__input" type="number" name="quantity" value="1" min="1" inputmode="numeric" autocomplete="off">
                <button class="quantity__button" name="plus" type="button">
                  <span class="visually-hidden">Increase quantity</span>
                  ${ICON_PLUS}
                </button>
              </quantity-input>
            `
                : ''
            }
            <button type="submit" class="btn btn--primary collection-add-cart-btn" ${available ? '' : 'disabled'}>
              <span>${available ? 'Add to Cart' : 'Sold Out'}</span>
            </button>
          </form>
          ${removable ? `<button type="button" class="wl-card-remove" data-wl-remove="${handle}">Remove from this list</button>` : ''}
        </div>
      </div>
    `;
  }

  // ---------------- Wishlist page ----------------
  const productCache = new Map();
  let renderToken = 0;
  let currentId = null;

  try {
    currentId = localStorage.getItem(VIEW_KEY);
  } catch (e) {}

  function setCurrent(id) {
    currentId = id;
    try {
      localStorage.setItem(VIEW_KEY, id);
    } catch (e) {}
  }

  function currentList() {
    const lists = window.Wishlist.getLists();
    return lists.find(l => l.id === currentId) || lists[0];
  }

  function getProduct(handle) {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`)
        .then(res => (res.ok ? res.json() : null))
        .catch(() => null));
    }
    return productCache.get(handle);
  }

  // A shared list arrives as ?shared=1&name=...&items=handle-a,handle-b
  function getShared() {
    const params = new URLSearchParams(location.search);
    if (!params.has('shared')) return null;
    const items = (params.get('items') || '')
      .split(',')
      .map(h => h.trim())
      .filter(h => /^[\w-]+$/.test(h))
      .slice(0, SHARED_MAX_ITEMS);
    return { name: (params.get('name') || '').trim().slice(0, 60) || 'Shared list', items };
  }

  function shareUrl(list) {
    return location.origin + location.pathname +
      '?shared=1&name=' + encodeURIComponent(list.name) +
      '&items=' + list.items.map(encodeURIComponent).join(',');
  }

  function setStatus(root, html) {
    const status = root.querySelector('[data-wl-status]');
    if (status) status.innerHTML = html;
  }

  function renderTabs(root, lists, active) {
    const tabs = root.querySelector('[data-wl-tabs]');
    tabs.innerHTML = lists.map(l => `
      <button type="button" class="wl-lists__tab${l.id === active.id ? ' is-active' : ''}" data-wl-select="${escapeHtml(l.id)}" aria-pressed="${l.id === active.id}">
        ${escapeHtml(l.name)} <span class="wl-lists__tab-count">${l.items.length}</span>
      </button>
    `).join('') + '<button type="button" class="wl-lists__tab wl-lists__tab--new" data-wl-new-toggle>+ New list</button>';
  }

  async function renderWishlistPage() {
    const root = document.querySelector('[data-wishlist-page]');
    if (!root || !window.Wishlist) return;

    const token = ++renderToken;
    const empty = root.querySelector('[data-wishlist-empty]');
    const grid = root.querySelector('[data-wishlist-grid]');
    const shared = getShared();
    const sharedBanner = root.querySelector('[data-wl-shared]');

    root.querySelector('[data-wl-manage]').hidden = !!shared;
    sharedBanner.hidden = !shared;

    let handles;
    if (shared) {
      sharedBanner.querySelector('[data-wl-shared-name]').textContent = shared.name;
      sharedBanner.querySelector('[data-wl-shared-count]').textContent = itemCount(shared.items.length);
      handles = shared.items;
      empty.textContent = 'This shared list is empty.';
    } else {
      const lists = window.Wishlist.getLists();
      const list = currentList();
      renderTabs(root, lists, list);
      root.querySelector('[data-wl-list-name]').textContent = list.name;
      root.querySelector('[data-wl-list-count]').textContent = itemCount(list.items.length);
      root.querySelector('[data-wl-addall]').disabled = !list.items.length;
      root.querySelector('[data-wl-share]').disabled = !list.items.length;
      handles = list.items;
      empty.textContent = 'This list is empty. Tap the heart on any product to save it here.';
    }

    if (!handles.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    if (!handles.every(h => productCache.has(h))) grid.innerHTML = '<p>Loading…</p>';

    const products = (await Promise.all(handles.map(getProduct))).filter(Boolean);
    if (token !== renderToken) return; // a newer render has started

    if (!products.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }

    grid.innerHTML = products.map((p, i) => cardMarkup(p, i, !shared)).join('');

    updateButtons();
  }

  async function addAllToCart(root, button) {
    const items = Array.from(root.querySelectorAll('[data-wishlist-grid] .collection-add-cart-form'))
      .map(form => {
        const qty = form.querySelector('[name="quantity"]');
        return { id: form.getAttribute('data-variant-id'), quantity: qty ? parseInt(qty.value, 10) || 1 : 0 };
      })
      .filter(item => item.id && item.quantity > 0); // sold-out cards have no quantity input

    if (!items.length) {
      setStatus(root, 'None of the products in this list are available right now.');
      return;
    }

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('btn--loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const parsed = await res.json();
      if (parsed.status) {
        setStatus(root, escapeHtml(parsed.description || parsed.message || 'Could not add these items to your cart.'));
        return;
      }

      if (window.FoxTheme && FoxTheme.pubsub) {
        try {
          const cartJson = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        } catch (e) {}
      }

      setStatus(root, `${itemCount(items.length)} added to your cart. <a href="/cart">View cart</a>`);
    } catch (e) {
      setStatus(root, 'Could not add these items to your cart.');
    } finally {
      button.removeAttribute('aria-disabled');
      button.classList.remove('btn--loading');
    }
  }

  function openSharePanel(root) {
    const list = currentList();
    const panel = root.querySelector('[data-wl-share-panel]');
    const url = shareUrl(list);
    const subject = 'Product list: ' + list.name;
    const body = `Here's our "${list.name}" product list (${itemCount(list.items.length)}):\n\n${url}`;

    panel.querySelector('[data-wl-share-url]').value = url;
    panel.querySelector('[data-wl-share-email]').href =
      'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    panel.hidden = false;
    panel.querySelector('[data-wl-share-url]').select();
  }

  function bindWishlistPage() {
    const root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    const newForm = root.querySelector('[data-wl-page-new]');
    const sharePanel = root.querySelector('[data-wl-share-panel]');

    root.addEventListener('click', (e) => {
      const select = e.target.closest('[data-wl-select]');
      if (select) {
        setCurrent(select.getAttribute('data-wl-select'));
        sharePanel.hidden = true;
        setStatus(root, '');
        renderWishlistPage();
        return;
      }

      if (e.target.closest('[data-wl-new-toggle]')) {
        newForm.hidden = false;
        newForm.elements.name.focus();
        return;
      }

      if (e.target.closest('[data-wl-new-cancel]')) {
        newForm.hidden = true;
        newForm.reset();
        return;
      }

      const remove = e.target.closest('[data-wl-remove]');
      if (remove) {
        window.Wishlist.removeFrom(currentList().id, remove.getAttribute('data-wl-remove'));
        return;
      }

      if (e.target.closest('[data-wl-rename]')) {
        const list = currentList();
        const name = window.prompt('Rename this list', list.name);
        if (name && name.trim()) window.Wishlist.renameList(list.id, name);
        return;
      }

      if (e.target.closest('[data-wl-delete]')) {
        const list = currentList();
        if (window.confirm(`Delete "${list.name}"? Products saved in your other lists won't be affected.`)) {
          window.Wishlist.deleteList(list.id);
          setCurrent(window.Wishlist.getLists()[0].id);
          sharePanel.hidden = true;
          renderWishlistPage();
        }
        return;
      }

      if (e.target.closest('[data-wl-share]')) {
        openSharePanel(root);
        return;
      }

      if (e.target.closest('[data-wl-share-close]')) {
        sharePanel.hidden = true;
        return;
      }

      const copy = e.target.closest('[data-wl-copy]');
      if (copy) {
        const input = sharePanel.querySelector('[data-wl-share-url]');
        const done = () => { copy.textContent = 'Link copied'; setTimeout(() => { copy.textContent = 'Copy link'; }, 2000); };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(input.value).then(done, () => { input.select(); });
        } else {
          input.select();
          document.execCommand('copy');
          done();
        }
        return;
      }

      const addAll = e.target.closest('[data-wl-addall]');
      if (addAll && !addAll.hasAttribute('aria-disabled')) {
        addAllToCart(root, addAll);
        return;
      }

      if (e.target.closest('[data-wl-shared-save]')) {
        const shared = getShared();
        history.replaceState(null, '', location.pathname);
        setCurrent(window.Wishlist.createList(shared.name, shared.items));
        renderWishlistPage();
      }
    });

    newForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = newForm.elements.name;
      if (!input.value.trim()) return;
      const id = window.Wishlist.createList(input.value);
      newForm.hidden = true;
      newForm.reset();
      sharePanel.hidden = true;
      setCurrent(id);
      renderWishlistPage();
    });
  }

  function showAddNotice(form) {
    const wrap = form.closest('.collection-add-cart-wrap');
    const notice = wrap && wrap.querySelector('.collection-add-notice');
    if (!notice) return;

    clearTimeout(notice._hideTimer);
    clearTimeout(notice._removeTimer);
    notice.hidden = false;
    void notice.offsetWidth;
    notice.classList.add('is-visible');

    notice._hideTimer = setTimeout(() => {
      notice.classList.remove('is-visible');
      notice._removeTimer = setTimeout(() => {
        notice.hidden = true;
      }, 200);
    }, 1800);
  }

  function bindAddToCart() {
    document.addEventListener('submit', function (event) {
      const form = event.target.closest && event.target.closest('.collection-add-cart-form');
      if (!form || !form.closest('[data-wishlist-page]')) return;

      event.preventDefault();

      const button = form.querySelector('.collection-add-cart-btn');
      if (!button || button.hasAttribute('aria-disabled')) return;

      const variantId = form.getAttribute('data-variant-id');
      if (!variantId) return;

      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      button.setAttribute('aria-disabled', 'true');
      button.classList.add('btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      })
        .then((response) => response.json())
        .then(async (parsedState) => {
          if (parsedState.status) {
            alert(parsedState.description || parsedState.message || 'Could not add this item to your cart.');
            return;
          }

          if (window.FoxTheme && FoxTheme.pubsub) {
            try {
              const cartJson = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            } catch (e) {}
          }

          showAddNotice(form);
        })
        .catch(() => {
          alert('Could not add this item to your cart.');
        })
        .finally(() => {
          button.removeAttribute('aria-disabled');
          button.classList.remove('btn--loading');
        });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindButtons();
    bindAddToCart();
    bindWishlistPage();
    updateButtons();
    renderWishlistPage();
  });

  window.addEventListener('wishlist:updated', () => {
    updateButtons();
    renderWishlistPage();
  });
})();
